const MaterialASMEII = require('./MaterialASMEII');
const materialsJson = require('./materiaisASMEII.json');

const materiais = materialsJson.map(
  material => new MaterialASMEII(material)
);

module.exports = materiais;

